/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Draftsconfirmdelete2Inputs */



/**

* @param {_Wiki_Draftsconfirmdelete2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_draftsconfirmdelete2 = /** @type {((inputs?: _Wiki_Draftsconfirmdelete2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Draftsconfirmdelete2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Entwurf wirklich löschen?")
});
export { _wiki_draftsconfirmdelete2 as "_wiki_draftsConfirmDelete" }